// Epicor pricing API client (staging summary, profiles, inspector, audit).
// Read-only; pipeline runs are enqueued through the Epicor jobs API
// (createEpicorJob with stage: 'pricing' | 'orders' | 'resolve' | 'audit').
import syncApi from './syncApi';

export const getPricingSummary = () =>
  syncApi.get('/pricing/summary').then((r) => r.data);

export const listPricingProfiles = (params) =>
  syncApi.get('/pricing/profiles', { params }).then((r) => r.data);

export const getPricingProfile = (profileId) =>
  syncApi.get(`/pricing/profiles/${profileId}`).then((r) => r.data);

export const listProfilePrices = (profileId, params) =>
  syncApi
    .get(`/pricing/profiles/${profileId}/prices`, { params })
    .then((r) => r.data);

export const listProfileCustomers = (profileId, environment = 'prod') =>
  syncApi
    .get(`/pricing/profiles/${profileId}/customers`, { params: { environment } })
    .then((r) => r.data);

export const getCustomerPriceListStatus = (company, custNum, environment) =>
  syncApi
    .get(`/pricing/customers/${company}/${custNum}/pricelist-status`, {
      params: environment ? { environment } : {},
    })
    .then((r) => r.data);

export const searchPricingCustomers = (company, q) =>
  syncApi
    .get('/pricing/customers/search', { params: { company, q } })
    .then((r) => r.data);

export const searchPricingParts = (company, q) =>
  syncApi
    .get('/pricing/parts/search', { params: { company, q } })
    .then((r) => r.data);

export const getCustomerPricingContext = (company, custNum) =>
  syncApi.get(`/pricing/customers/${company}/${custNum}`).then((r) => r.data);

export const resolveCustomerPrice = (company, custNum, partNum, qty = 1) =>
  syncApi
    .get(`/pricing/customers/${company}/${custNum}/resolve`, {
      params: { part_num: partNum, qty },
    })
    .then((r) => r.data);

export const listCustomerPrices = (company, custNum, params) =>
  syncApi
    .get(`/pricing/customers/${company}/${custNum}/prices`, { params })
    .then((r) => r.data);

export const getAuditSummary = (company) =>
  syncApi
    .get('/pricing/audit/summary', { params: company ? { company } : {} })
    .then((r) => r.data);

export const listAuditLines = (params) =>
  syncApi.get('/pricing/audit/lines', { params }).then((r) => r.data);
